module.exports = __webpack_public_path__ + "dd1fafaf1755327edf9a0431380477f3.svg";